export default __webpack_public_path__ + "static/media/3-cheese.f641536c.png";